import { render, staticRenderFns } from "./XFrom.vue?vue&type=template&id=270573f3&scoped=true"
import script from "./XFrom.vue?vue&type=script&lang=js"
export * from "./XFrom.vue?vue&type=script&lang=js"
import style0 from "./XFrom.vue?vue&type=style&index=0&id=270573f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270573f3",
  null
  
)

export default component.exports